'use es6';

import Immutable from 'immutable';
import { createSelector } from 'reselect';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import { isFulfilled, isSucceeded } from 'ecosystem-marketplace-core/utils/requestState';
const EMPTY_LIST = Immutable.List();

const getAllCollectionsState = state => state.allCollections;

export const makeGetCollectionRequestState = () => createSelector([getAllCollectionsState, (__state, collectionId) => collectionId], ({
  collectionsById
}, collectionId) => collectionsById.getIn([collectionId, 'requestState'], RequestStates.UNINITIALIZED));
export const makeGetCollectionItems = () => createSelector([getAllCollectionsState, (__state, collectionId) => collectionId], ({
  collectionsById
}, collectionId) => collectionsById.getIn([collectionId, 'items'], EMPTY_LIST));
export const getHasAnySucceededRequests = createSelector([getAllCollectionsState], ({
  collectionsById
}) => !collectionsById.isEmpty() && collectionsById.some(collectionState => isSucceeded(collectionState.get('requestState'))));
export const getHasAllFulfilledRequests = createSelector([getAllCollectionsState], ({
  collectionsById
}) => !collectionsById.isEmpty() && collectionsById.every(collectionState => isFulfilled(collectionState.get('requestState'))));